import React, { Component } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as IcoMenu } from "../../../res/iconos/menu.svg";
import Menu from "./menu.jsx";
import { CSSTransition } from "react-transition-group";

function withRouterAndNavigate(Component) {
  function ComponentWithRouterAndNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    let location = useLocation();
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  }
  return ComponentWithRouterAndNavigate;
}

class NavBar extends Component {
  state = { mostrarMenu: false, nivelLogin: this.props.nivelLogin, region: null, icono: "int" };

  componentDidMount() {
    const regiones = ['mexico','bolivia'];

    const primero = this.props.location.pathname.split("/")[1];

    let icono = regiones.find((r) => r == primero)??'int';
    let region = icono == 'int'?null:icono;

    this.setState({ region, icono });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin || prevProps.location.pathname != this.props.location.pathname) {
      const regiones = ['mexico','bolivia'];
      const primero = this.props.params['*'].split("/")[0];
      let region;
      let icono = regiones.find((r) => r == primero)??'int';
      if (icono != 'int') {
        region = icono;
      } else {
        region = null;
      }
      this.setState({ nivelLogin: this.props.nivelLogin, region, icono });
    }
  }

  ocultarMenu() {
    this.setState({ mostrarMenu: false });
  }

  setRegion(region) {
    let siguiente;
    let icono = region??'int';
    if (region != this.state.region) {
      if (region == null) {
        siguiente = "/home";
      } else {
        siguiente = "/" + region;
      }
    }
    this.setState({region: region, icono: icono}, () => {if (siguiente) this.props.navigate(siguiente)})
  }

  render() {
    const mobile = window.innerWidth < 1000;

    return (
      <div
        style={{
          width: "100%",
          top: 0,
          position: "sticky",
          background: "#494949",
          height: 80,
          zIndex: 100,
        }}
      >
        <div style={mobile?{height: "100%"}:{paddingLeft: "10%", paddingRight: "10%", height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "14%"}}>
          <Link
            to={this.state.region?("/"+this.state.region):"/home"}
            onClick={() => {
              this.setState({ mostrarMenu: false });
            }}
          >
            <img src={require("../../../res/iconos/logoNuevo.png")} style={mobile?{objectFit: "contain", height: "100%", width: "50%", maxWidth: 200, marginLeft: "10%", paddingTop: 10, paddingBottom: 10, display: "inline"}:{objectFit: "contain", width: 172}} />
          </Link>
          {mobile && (
            <React.Fragment>
              <div
                onClick={() => {
                  this.setState({ mostrarMenu: !this.state.mostrarMenu });
                }}
                style={{
                  display: "flex",
                  float: "right",
                  marginRight: "10%",
                  height: "100%",
                  position: "relative"
                }}
              >
                <IcoMenu
                  width={35}
                />
              </div>
              <CSSTransition
                in={this.state.mostrarMenu}
                timeout={100}
                classNames="opacidad"
                unmountOnExit
              >
                <Menu
                  mobile={mobile}
                  ocultar={this.ocultarMenu.bind(this)}
                  nivelLogin={this.state.nivelLogin}
                  botones={this.props.botones}
                  region={this.state.region}
                  icono={this.state.icono}
                  setRegion={this.setRegion.bind(this)}
                />
              </CSSTransition>
            </React.Fragment>
          )}
          {!mobile && (
            <Menu
              mobile={mobile}
              ocultar={this.ocultarMenu.bind(this)}
              nivelLogin={this.state.nivelLogin}
              botones={this.props.botones}
              region={this.state.region}
              icono={this.state.icono}
              setRegion={this.setRegion.bind(this)}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouterAndNavigate(NavBar);
